// extracted by mini-css-extract-plugin
export default {"starButton":"Nav_starButton__j0C8B","logo":"Nav_logo__0YvBH","navContainer":"Nav_navContainer__XOJ+z"};